module.exports = __webpack_public_path__ + "img/Morbida_round.504bd1ee.png";